import { Text } from "@ui-component-library";
import { TailwindWrapper } from "@utils/TailwindWrapper";
import MediaSelector from "../editor/fields/MediaSelector";

const DEFAULTS = {
  date: "Nov 11, 2024",
  category: "Articles",
  title: "Short and clear engaging headline for an article",
  description:
    "A concise introduction that expands on the headline and sets up the article. Keep it scannable and direct.",
  authorName: "Lando Norris",
  authorTitle: "Product Designer",
  authorAvatarUrl:
    "https://placehold.co/96x96/e5e5e5/737373?text=Avatar",
} as const;

export const HeaderPosts = (props: {
  date?: string;
  category?: string;
  title?: string;
  description?: string;
  authorName?: string;
  authorTitle?: string;
  authorAvatarUrl?: string;
}) => (
  <TailwindWrapper>
    <div className="container w-full py-12 lg:py-24">
      <div className="mx-auto w-full max-w-[720px] px-4 sm:px-6">
        <Text
          variant="text-sm/leading-normal/normal"
          className="mb-4 text-[#737373]"
        >
          {props.date || DEFAULTS.date} · {props.category || DEFAULTS.category}
        </Text>

        <Text
          as="h1"
          variant="text-4xl/leading-normal/medium"
          lg="text-5xl/leading-normal/medium"
          className="mb-4"
        >
          {props.title || DEFAULTS.title}
        </Text>

        <Text
          variant="text-lg/leading-normal/normal"
          className="mb-8 text-[#737373]"
        >
          {props.description || DEFAULTS.description}
        </Text>

        <div className="flex items-center gap-3">
          <img
            src={props.authorAvatarUrl || DEFAULTS.authorAvatarUrl}
            alt=""
            className="size-12 shrink-0 rounded-full object-cover"
          />
          <div>
            <Text as="div" variant="text-base/leading-normal/medium">
              {props.authorName || DEFAULTS.authorName}
            </Text>
            <Text
              variant="text-sm/leading-normal/normal"
              className="text-[#737373]"
            >
              {props.authorTitle || DEFAULTS.authorTitle}
            </Text>
          </div>
        </div>
      </div>
    </div>
  </TailwindWrapper>
);

HeaderPosts.defaultProps = { ...DEFAULTS };

HeaderPosts.fields = {
  date: { type: "text", label: "Date" },
  category: { type: "text", label: "Category" },
  title: { type: "text", label: "Title" },
  description: { type: "textarea", label: "Intro / description" },
  authorName: { type: "text", label: "Author name" },
  authorTitle: { type: "text", label: "Author title" },
  authorAvatarUrl: {
    type: "custom",
    label: "Author image",
    render: ({
      name,
      onChange,
      value,
    }: {
      name: string;
      onChange: (value: string) => void;
      value: string;
    }) => (
      <MediaSelector
        name={name}
        label="Author image"
        type="img"
        onChange={onChange}
        value={value}
      />
    ),
  },
};
